import styles from './third-party-session-timeout.module.scss';
import UTEButton from 'src/components/ute-button';
import { Modal, Col, Row } from 'react-bootstrap';

type ThirdPartySessionTimeoutProps = {
	countDownMinutes?: number;
	onSubmit: () => void;
};

const ThirdPartySessionTimeout = ({ countDownMinutes = 15, onSubmit }: ThirdPartySessionTimeoutProps) => {
	return (
		<div className={styles.thirdPartySessionTimeoutPopupModal}>
			<Modal.Body>
				<Row data-test-auto='F12E9E3A-5B0D-4463-9329-750FAA9B7D12'>
					<Col lg={12}>
						<p>
							Your session will expire in <span style={{ fontWeight: '700' }}>{countDownMinutes} minutes</span>. Once it
							expires, you will be automatically logged out.
						</p>
						<p>If you need more time, please log in again using the provided access link.</p>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<span></span>
				<UTEButton
					dataTestAuto='FG23CDEF-A642-4D28-9C11-E6913BC2C2C0'
					className='btn btn-primary'
					onClick={onSubmit}
					disabled={false}
					text='OK'></UTEButton>
			</Modal.Footer>
		</div>
	);
};

export default ThirdPartySessionTimeout;
